import { format, formatDistanceToNowStrict, isTomorrow, isYesterday, isValid, parseISO, isToday } from 'date-fns';
import { getDays, localeMap } from '../constants/Constants';
import i18n from '../i18n';

const date_format = 'dd MMM yyyy';
const long_date_format = 'dd MMM yyyy';
const group_date_format = 'EEEE, d MMM yyyy';

// Absolute, locale-aware date with no relative wording ("12 Mar 2025"). Used by
// the Inactivity table where "3 days ago" would be ambiguous next to a threshold.
// Accepts an ISO string, epoch ms, or Date; returns '' for anything unparseable.
export const format_date_long = (date, locale = i18n.language) => {
	if (date === null || date === undefined || date === '') return '';
	const parsed = typeof date === 'string' ? parseISO(date) : new Date(date);
	if (!isValid(parsed)) return '';
	try {
		return format(parsed, long_date_format, { locale: localeMap[locale] });
	} catch {
		return '';
	}
};

// Day heading for a date-grouped list: "Today" / "Yesterday" / "Tomorrow", otherwise
// the full weekday and date ("Monday, 3 Mar 2025"). '' for anything unparseable.
export const format_group_day = (date, locale = i18n.language) => {
	if (date === null || date === undefined || date === '') return '';
	const parsed = typeof date === 'string' ? parseISO(date) : new Date(date);
	if (!isValid(parsed)) return '';
	if (isToday(parsed)) return i18n.t('today');
	if (isYesterday(parsed)) return i18n.t('yesterday');
	if (isTomorrow(parsed)) return i18n.t('tomorrow');
	try {
		return format(parsed, group_date_format, { locale: localeMap[locale] });
	} catch {
		return '';
	}
};

export const format_day = (date, hours = true, locale = i18n.language) => {
	if (typeof date == 'string') date = parseISO(date);
	try {
		const formatted_date = formatDistanceToNowStrict(date, { includeSeconds: true, addSuffix: 'ago', unit: 'day' });
		const duration = formatted_date.split(' ')[0];
		if (isToday(date)) {
			return ' ' + i18n.t('today') + ` ${hours ? format(date, ' HH:mm') : ''}`;
		} else if (isTomorrow(date)) {
			return ' ' + i18n.t('tomorrow') + ` ${hours ? format(date, ' HH:mm') : ''}`;
		} else if (isYesterday(date)) {
			return ' ' + i18n.t('yesterday') + ` ${hours ? format(date, ' HH:mm') : ''}`;
		} else if (duration > 6) {
			return format(date, date_format + (hours ? ' HH:mm' : ''), { locale: localeMap[locale] });
		} else {
			const day = new Date(date).getDay();
			return `${getDays()[day]}${hours ? format(date, ' HH:mm') : ''}`;
		}
	} catch {
		return '';
	}
};
